import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

async function writeClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  }
}

export default function CopyButton({ text, label = "Copy", testid, className, variant = "ghost" }) {
  const [copied, setCopied] = useState(false);
  const onClick = async (e) => {
    e.stopPropagation();
    await writeClipboard(typeof text === "function" ? text() : text);
    setCopied(true);
    toast.success("Copied to clipboard");
    setTimeout(() => setCopied(false), 1600);
  };
  return (
    <button type="button" onClick={onClick} data-testid={testid}
      className={cn(variant === "brand" ? "btn-brand h-10 px-5 text-sm" : "btn-ghost h-8 px-3 text-xs", className)}>
      {copied ? <Check className="h-3.5 w-3.5 text-brand-hover" /> : <Copy className="h-3.5 w-3.5" />}
      {label && <span>{copied ? "Copied" : label}</span>}
    </button>
  );
}
